import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Icon from 'components/Icon';

import A from 'modules/Link/components/Link';

import { getUserPhotoURL } from 'utils';
import { useChangeAvatar } from 'utils/avatar';

import theme from 'styles/theme';

import { MenuDropdown } from './Header.styled';

const Profile = ({ user, signOut, showContactModal, linkClickHandler }) => {
  const [isActive, setIsActive] = useState(false);

  const { avatarURL } = useChangeAvatar();

  const toggleActive = () => {
    setIsActive((state) => !state);
  };

  const showContact = () => {
    showContactModal();
    setIsActive(false);
  };

  const goToProfile = (e) => {
    toggleActive();
    linkClickHandler(e);
  };

  return (
    <MenuDropdown>
      <Button
        type="button"
        styled
        rounded
        className="dropdown-button"
        onClick={toggleActive}>
        {avatarURL && avatarURL.length > 0 ? (
          <img
            src={getUserPhotoURL(avatarURL)}
            alt={user.displayName}
            height="34px"
            width="34px"
            style={{ objectFit: 'cover' }}
          />
        ) : (
          <>
            {(user.displayName && user.displayName.charAt(0)) ||
              (user.email && user.email.charAt(0))}
          </>
        )}
      </Button>
      {isActive && (
        <Button
          type="button"
          onClick={toggleActive}
          className="popup-wrapper absolute-inset"
        />
      )}
      <ul className={`dropdown-menu${isActive ? ' active' : ''}`}>
        <li>
          <A href="/profile" onClick={goToProfile}>
            Account Settings
          </A>
        </li>
        <li>
          <A href="/billing" onClick={goToProfile}>
            My Plan
          </A>
        </li>
        <li>
          <Button type="button" onClick={showContact}>
            Contact Us
          </Button>
        </li>
        <li style={{ marginLeft: -2 }}>
          <a
            href="https://ruttl.com/affiliate/"
            target="_blank"
            rel="noopener noreferrer">
            <Icon name="moneybag" verticalAlign="bottom" />
            &nbsp;Refer &amp; Earn
          </a>
        </li>
        <li
          style={{
            borderTop: `1px solid ${theme.colors.deepLightGrey}`,
            marginTop: 5,
            paddingTop: 10,
            paddingBottom: 0,
          }}>
          <Button type="button" onClick={signOut}>
            Sign Out
          </Button>
        </li>
      </ul>
    </MenuDropdown>
  );
};

Profile.propTypes = {
  user: PropTypes.object.isRequired,
  signOut: PropTypes.func.isRequired,
  showContactModal: PropTypes.func.isRequired,
  linkClickHandler: PropTypes.func.isRequired,
};

export default Profile;
